import React from "react";
import { goToCheckout, CHECKOUT_URL } from "../utils/pixel";
export function MobileCtaBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-ink/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-125" data-mp="1oxvphvch5i35">
      <div className="flex items-center gap-3" data-id="element-126" data-mp="1t1jxgf50qfox">
        <div className="leading-tight" data-id="element-127" data-mp="1xzd0izb0ytkz">
          <p className="text-[10px] font-semibold tracking-wider text-mute" data-id="element-128" data-mp="1xyaa0shm6t5l">2 LIVRES + 5 BONUS</p>
          <p className="font-display text-2xl text-gold" data-id="element-129" data-mp="11a41huhkngm1">27 $ US</p>
        </div>
        <a href={CHECKOUT_URL} onClick={e => {
        e.preventDefault();
        goToCheckout();
      }} className="flex-1 rounded-full bg-gold py-3.5 text-center text-sm font-bold text-ink transition-transform duration-150 ease-out active:scale-[0.98]" data-id="element-130" data-mp="15a6200bkm3zq">
          Je veux le pack complet
        </a>
      </div>
    </div>;
}